import { useMemo, type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { usStates } from 'constants/states';

import BaseSelect from './base';

import type { Option } from './base';

interface Props {
  value?: Option[];
  onChange: (e: Option[]) => void;
  showSelectAll?: boolean;
  width?: string;
}

const StateSelect: FC<Props> = ({
  onChange,
  value,
  showSelectAll = false,
  width = '100%',
}) => {
  const { t } = useTranslation();
  const options = useMemo(() => {
    return usStates.map((item) => ({
      label: item.label,
      value: item.id,
      title: item.label,
    }));
  }, []);

  return (
    <BaseSelect
      width={width}
      label={t('labels.state')}
      data-cy="filter-state"
      placeholder={t('labels.all')}
      mode="multiple"
      showSelectAll={showSelectAll}
      options={options}
      value={value}
      onChange={(newValues) => {
        const items = Array.isArray(newValues) ? newValues : [newValues];
        onChange(items);
      }}
    />
  );
};

export default StateSelect;
